import { doc, getDoc, serverTimestamp, updateDoc } from 'firebase/firestore';
import { auth, db } from './config';
import { getDateKey } from '../games/Crossword/crosswordUtils';
import { updateLeaderboardEntry } from './leaderboardService';
import { advanceAfterPlay } from '../utils/calendarStreak';
import { isE2E, e2eAppendCall } from '../e2e/globals';

function isOfflineError(err) {
  return err?.code === 'unavailable' || err?.message?.includes('offline');
}

export async function recordCrosswordPlay(score, wordsFound, starCount) {
  if (isE2E()) {
    e2eAppendCall('recordCrosswordPlay', { score, wordsFound, starCount });
    return { ok: true, e2e: true };
  }

  const user = auth.currentUser;
  if (!user) return null;
  try {
    const userRef = doc(db, 'users', user.uid);
    const snap = await getDoc(userRef);
    if (!snap.exists()) return null;

    const data = snap.data();
    const today = getDateKey();

    const xs = { ...(data.crosswordStats || {}) };
    const prevBest = (xs.bestScore ?? 0) | 0;
    const newBest = Math.max(prevBest, score);
    if (newBest > prevBest) xs.bestScore = newBest;
    xs.lastDailyCompletedDate = today;

    const current = (data.globalStreak ?? 0) | 0;
    const lastPlayed = data.lastPlayedGlobalDate ?? null;
    const global = advanceAfterPlay({ playDate: today, lastPlayed, currentStreak: current });
    const didAdvanceGlobal = global.streak > current || global.lastPlayed !== lastPlayed;

    await updateDoc(userRef, {
      crosswordStats: xs,
      ...(didAdvanceGlobal
        ? {
            globalStreak: global.streak,
            lastPlayedGlobalDate: global.lastPlayed,
          }
        : {}),
      updatedAt: serverTimestamp(),
    });

    const name = data.displayName || user.displayName || user.email?.split('@')[0] || 'Player';
    if (newBest > prevBest) await updateLeaderboardEntry('crossword_best', user.uid, name, newBest);
    if (didAdvanceGlobal) {
      await updateLeaderboardEntry('global_streak', user.uid, name, global.streak);
    }

    return { ok: true };
  } catch (err) {
    if (isOfflineError(err)) return null;
    throw err;
  }
}
